
export const formState = {
    values :{
        id : '',
        customerId : '',
        merchantId : '',
        invoiceType: '',
        orderId : '',
        amount : null,
        currency : '',
        networkName : '',
        isPayCommission : false
    },
    lookups : {
        currencyLookup : [],
        networkLookup :[],
        merchantLookup : [],
    },
    isLoading: false,
    errors:null,
    selectedNetwork:{},
}
export const formReducer = (state, action) => {
    state = state || formState;
    switch (action.type) {
          case "setValues":
            state = { ...state, values: action.payload };
            return state;
          case "setErrors":
            state = { ...state, errors: action.payload };
            return state;
        case "setLookups":
            state = { ...state, lookups: action.payload };  
            return state;
        case "setIsLoading":
            state = { ...state, isLoading: action.payload };
            return state;
        case "setSelectedNetwork":
            state = { ...state, selectedNetwork: action.payload };
            return state;
        default:
            return state;
    }
};